"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AMPLIFY_PARTNER_RELIEF = exports.TRACKING_PARAMS = exports.PIESYNC_PROD_NATIVE_ID = exports.PIESYNC_PROD_OFFERING_ID = exports.PIESYNC_QA_NATIVE_ID = exports.PIESYNC_QA_OFFERING_ID = exports.NAV_BAR_HEIGHT_INT = exports.ALL_COLLECTIONS_LENGTH = exports.NEW_COLLECTION_SEARCH_LENGTH = exports.DEFAULT_SEARCH_LENGTH = exports.MAX_INSTALLS_BUCKET = exports.SMALL_ICON_SIZE = exports.DEFAULT_ICON_SIZE = exports.MAIN_SECTION_MAX_WIDTH = exports.MAIN_SECTION_PADDING_X = exports.MAIN_SECTION_PADDING_Y = void 0;

var _globalNavHeight = _interopRequireDefault(require("nav-meta/global-nav-height"));

var MAIN_SECTION_PADDING_Y = 40;
exports.MAIN_SECTION_PADDING_Y = MAIN_SECTION_PADDING_Y;
var MAIN_SECTION_PADDING_X = 48;
exports.MAIN_SECTION_PADDING_X = MAIN_SECTION_PADDING_X;
var MAIN_SECTION_MAX_WIDTH = 1280;
exports.MAIN_SECTION_MAX_WIDTH = MAIN_SECTION_MAX_WIDTH;
var DEFAULT_ICON_SIZE = 85;
exports.DEFAULT_ICON_SIZE = DEFAULT_ICON_SIZE;
var SMALL_ICON_SIZE = 32;
exports.SMALL_ICON_SIZE = SMALL_ICON_SIZE;
var MAX_INSTALLS_BUCKET = 10000;
exports.MAX_INSTALLS_BUCKET = MAX_INSTALLS_BUCKET;
var DEFAULT_SEARCH_LENGTH = 45;
exports.DEFAULT_SEARCH_LENGTH = DEFAULT_SEARCH_LENGTH;
var NEW_COLLECTION_SEARCH_LENGTH = 24;
exports.NEW_COLLECTION_SEARCH_LENGTH = NEW_COLLECTION_SEARCH_LENGTH;
var ALL_COLLECTIONS_LENGTH = 3;
exports.ALL_COLLECTIONS_LENGTH = ALL_COLLECTIONS_LENGTH;
var NAV_BAR_HEIGHT_INT = parseInt(_globalNavHeight.default, 10);
exports.NAV_BAR_HEIGHT_INT = NAV_BAR_HEIGHT_INT;
var PIESYNC_QA_OFFERING_ID = 737;
exports.PIESYNC_QA_OFFERING_ID = PIESYNC_QA_OFFERING_ID;
var PIESYNC_QA_NATIVE_ID = '1175334';
exports.PIESYNC_QA_NATIVE_ID = PIESYNC_QA_NATIVE_ID;
var PIESYNC_PROD_OFFERING_ID = 161;
exports.PIESYNC_PROD_OFFERING_ID = PIESYNC_PROD_OFFERING_ID;
var PIESYNC_PROD_NATIVE_ID = '32450';
exports.PIESYNC_PROD_NATIVE_ID = PIESYNC_PROD_NATIVE_ID;
var TRACKING_PARAMS = ['utm_medium', 'utm_source', 'utm_campaign', 'utm_id', 'utm_content', 'hubs_signup-url', 'hubs_signup-cta'];
exports.TRACKING_PARAMS = TRACKING_PARAMS;
var AMPLIFY_PARTNER_RELIEF = 'partner-relief';
exports.AMPLIFY_PARTNER_RELIEF = AMPLIFY_PARTNER_RELIEF;


//////////////////
// WEBPACK FOOTER
// ./js/constants/index.js
// module id = 72
// module chunks = 209 210 211 212 213